import React, { useCallback, useEffect } from 'react';
import { getDownload, getShareLinks } from '../../Utils/Api';
import LoadingOverlay from '../LoadingOverlay';
import GalleryDialogLazy from './GalleryDialogLazy';

export function useLoadEntryImages(awardId, entryId, images) {
    const [fullImageData, setFullImageData] = React.useState(null);
    const [loading, setLoading] = React.useState(true)

    useEffect(() => {
        (async () => {
            if(!images) return null;

            const imageResp = await getShareLinks(awardId, entryId, images.map(image => image.id));
            console.log("imageResp", imageResp);
            if(imageResp?.data?.shareLinks) {
                const originalImageUrls = imageResp.data.shareLinks;

                const fullImageData = images.map(image => ({
                    ...image,
                    src: originalImageUrls[image.id] ? originalImageUrls[image.id].url : null,
                }))

                setFullImageData(fullImageData);
            }
            setLoading(false);
        })();
    }, [awardId, entryId, images]);

    const reloadImageFn = useCallback(async (imageToLoad) => {

        const imageResp = await getDownload(awardId, entryId, imageToLoad.id);

        console.log("imageResp", imageResp);
        if(imageResp?.data?.url) {
            const imageUrl = imageResp.data.url;

            setFullImageData(fullImageData.map(image => {
                if(image.id === imageToLoad.id) {
                    return {
                        ...image,
                        src: imageUrl,
                    }
                }
                return image;
            }));
        }
    }, [awardId, entryId, fullImageData]);

    return loading 
        ? null 
        : {
            status: loading ? 'loading' : 'done',
            images: fullImageData,
            reloadImage: reloadImageFn,
        }
    ;
}

export default function EntryGalleryDialog({ loading, reloadImage, handleClose, currentImageId, onImageChange, open, images: fullImageData}) {

    if(open && loading) return (
        <LoadingOverlay />
    )
    return <>{fullImageData && (
        <GalleryDialogLazy 
            handleClose={handleClose} 
            open={open}
            images={fullImageData} 
            currentImageId={currentImageId} 
            reloadImage={reloadImage}
            onImageChange={onImageChange}
        />
    )}</>;
}